import { ApiManagement } from '@/models/api-management';
import { AxiosResponse } from 'axios';
import { PaginationResponse } from '../models/pagination-response';
import { deleteAsync, getAsync, postAsync, postFormDataAsync } from './http-client';

const baseUrl = `${process.env.REACT_APP_API_ENDPOINT_Portal}/v1`;

function getApiManagementsByFilter(
  pageIndex: number,
  pageSize: number,
  searchString: string
): Promise<AxiosResponse<PaginationResponse<ApiManagement>>> {
  const url = `${baseUrl}/apimanagement?pageIndex=${pageIndex}&pageSize=${pageSize}&searchString=${searchString}`;
  return getAsync(url,undefined,true, true,false);
}

function createApiManagement(
  model: ApiManagement
): Promise<AxiosResponse<ApiManagement>> {
  const url = `${baseUrl}/apimanagement`;
  return postFormDataAsync(url, model, true, true);
}

function getApiManagementById(id: string) : Promise<AxiosResponse<ApiManagement>> {
  const url = `${baseUrl}/apimanagement/${id}`;
  return getAsync(url,undefined,true,true);
}

function activeApiManagement(id: string, isDeactive?: boolean) {
  const url = `${baseUrl}/apimanagement/active/${id}/${isDeactive}`;
  return postAsync(url, undefined, true, true);
}

function deleteApiManagement(id: string) {
  const url = `${baseUrl}/apimanagement/${id}`;
  return deleteAsync(url, undefined, true, true);
}

function getCurrentAppSercet(id: string): Promise<AxiosResponse<string>> {
  const url = `${baseUrl}/apimanagement/get-app-secret/${id}`;
  return getAsync(url, undefined, true, true);
}

export const ApiManagementApi = {
  getApiManagementsByFilter,
  activeApiManagement,
  createApiManagement,
  deleteApiManagement,
  getApiManagementById,
  getCurrentAppSercet,
};
